/* eslint-disable */
require('./arrow-next')
require('./arrow-prev')
require('./arrow-prev2')
require('./arrow-right')
require('./arrow-right2')
require('./arrow-up')
require('./banner-line')
require('./checkbox-off')
require('./checkbox-on')
require('./cross-bold')
require('./cross')
require('./delete')
require('./download')
require('./flavour-bg')
require('./geo')
require('./logo-dark')
require('./logo-gold-new')
require('./logo-gold')
require('./logo-white')
require('./logo')
require('./plus')
require('./shop')
require('./signature')
require('./signature2-white')
require('./signature2')
